export enum AppointmentBookingSource {
  GetCareDeepLinkFlow = 'GetCareDeepLinkFlow',
  Email = 'email',
}
